import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { TableWrapper } from "@portal/BaseComponents/Table/Components/style";
import { defaultColumnDefs } from "@portal/BaseComponents/Table/default";
import { Formats } from "@portal/hooks/use-formats";
import { useDisputeListQuery } from "@portal/queries/dispute-query";
import { disputeFiltersAtom } from "@portal/store/Filters/dipsutes/dispute-filter";
import { tableAtom } from "@portal/store/table/table";
import { DisputeList } from "@portal/types/entities/dispute";
import { Sorter, Table } from "@sinecycle/growcomponents";
import produce from "immer";
import { useAtom, useAtomValue } from "jotai";
import { useColumns } from "./Columns/useColumns";
import { useCustomFieldColumns } from "@portal/hooks/useCustomFieldColumns";
import { useGetCustomFieldsBasedOnType } from "@portal/queries/custom-field-query";
import { customFieldAtom } from "@portal/store/Filters/customFields/custom-field";
type DisputeActionPrivileges = {
  customField: boolean;
};
interface DisputeListsProps {
  extra: Formats;
  actionPrivileges?: DisputeActionPrivileges;
}
function DisputeLists(props: DisputeListsProps) {
  const [tableValue, setTable] = useAtom(tableAtom);
  const [disputeFilters, setFilters] = useAtom(disputeFiltersAtom);
  const customFieldValue = useAtomValue(customFieldAtom);
  const filters = produce(disputeFilters.filterValues, (draft) => {
    draft.custom_fields = customFieldValue.filterValues.DISPUTES.length
      ? customFieldValue.filterValues.DISPUTES
      : undefined;
  });
  const { data, isLoading } = useDisputeListQuery({
    page: tableValue.currentPage,
    size: 10,
    filters: {
      ...filters,
      ...disputeFilters.sorting,
      ...disputeFilters.filterValues,
    },
  });

  const { defaultColConfigs } = useColumns(props.extra);
  const { handleErrorCallBack, handleSuccessCallback, columns, columnLoading } =
    useCustomFieldColumns(defaultColConfigs, "DISPUTE_PORTAL");
  const { isLoading: cFLoading } = useGetCustomFieldsBasedOnType(
    'DISPUTE',
    handleSuccessCallback,
    Boolean(props.actionPrivileges?.customField),
    handleErrorCallBack
  );
  const loading = isLoading || cFLoading || columnLoading;

  function handleSort(sortParams: Sorter) {
    setFilters((filter) => {
      return produce(filter, (draft) => {
        draft.sorting = {
          order: sortParams.sortOrder,
          sort_col: sortParams.sortCol,
        };
      });
    });
  }

  return (
    <TableWrapper>
      <Table<DisputeList>
        loading={loading}
        gridProps={{
          rowData: data?.list,
          columnDefs: columns,
          defaultColDef: {
            ...defaultColumnDefs,
            autoHeight: false,
            sortable: false,
          },
          stopEditingWhenCellsLoseFocus: true,
          animateRows: true,
          suppressMovableColumns: true,
          components: cellComponents,
          unSortIcon: true,
          enableCellTextSelection: true,
        }}
        tableState={tableValue}
        handlePageChange={(page) => {
          setTable((value) => {
            return produce(value, (draft) => {
              draft.currentPage = page;
              return draft;
            });
          });
        }}
        sortMode={{
          type: "remote",
          onSortChange: handleSort,
        }}
        enableColumnCustom={{
          type: "header-only",
          content: {
            preserve: {
              type: "LOCAL",
              storageKey: "DISPUTE_LIST_PORTAL",
            },
           
          },
        }}
      />
    </TableWrapper>
  );
}

export { DisputeLists };
